module.exports = __webpack_public_path__ + "434e306a6b47e2af422b353c239dfd70.png";